<template>
  <b-modal v-model="visible" centered hide-footer hide-header>
    <div class="my-gerr">
      <div class="my-gerr-head">
        <div class="my-gerr-icon">
          <i class="fas fa-exclamation-triangle"></i>
        </div>
        <span class="my-gerr-close" @click="visible = false">&times;</span>
      </div>

      <h5 class="my-gerr-title">{{ $t("Error") || "Xatolik" }}</h5>
      <p class="my-gerr-msg">{{ message }}</p>

      <div v-if="details" class="my-gerr-actions">
        <button class="my-gerr-btn" @click="showDetails = !showDetails">
          <i :class="showDetails ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
          {{ showDetails ? $t("Hide") || "Yopish" : $t("ShowAll") || "Hammasini ko'rish" }}
        </button>
        <button class="my-gerr-btn" @click="copyError">
          <i :class="copied ? 'fas fa-check' : 'far fa-copy'"></i>
          {{ copied ? $t("Copied") || "Nusxalandi" : $t("Copy") || "Nusxalash" }}
        </button>
      </div>

      <pre v-if="showDetails && details" class="my-gerr-details">{{ details }}</pre>
    </div>
  </b-modal>
</template>

<script>
import { BModal } from "bootstrap-vue";
export default {
  name: "GlobalErrorModal",
  components: { BModal },
  data() {
    return {
      visible: false,
      message: "",
      details: "",
      showDetails: false,
      copied: false,
    };
  },
  methods: {
    showError(message, details) {
      this.message = message || "";
      this.details = details || "";
      this.showDetails = false;
      this.copied = false;
      this.visible = true;
    },
    copyError() {
      var text = this.details || this.message;
      var done = () => {
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
        }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done, () => done());
      } else {
        var ta = document.createElement("textarea");
        ta.value = text;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        try {
          document.execCommand("copy");
        } catch (e) {
          // ignore
        }
        document.body.removeChild(ta);
        done();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.my-gerr {
  padding: 8px 4px;
  text-align: center;

  &-head {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    position: relative;
  }

  &-icon {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: #fdecef;
    color: #ef5579;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 26px;
    margin: 4px auto 12px;
  }

  &-close {
    position: absolute;
    top: -6px;
    right: 0;
    cursor: pointer;
    font-size: 26px;
    line-height: 1;
    color: #9aa0a6;
    &:hover {
      color: #5f6368;
    }
  }

  &-title {
    margin: 0 0 6px;
    font-weight: 700;
    color: #293958;
  }

  &-msg {
    margin: 0 0 16px;
    color: #5f6368;
    font-size: 14px;
    line-height: 1.5;
  }

  &-actions {
    display: flex;
    gap: 10px;
    justify-content: center;
    flex-wrap: wrap;
  }

  &-btn {
    border: 1px solid #e3e6ea;
    background: #f7f7f7;
    color: #293958;
    border-radius: 12px;
    padding: 8px 16px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s ease;
    display: inline-flex;
    align-items: center;
    gap: 6px;

    &:hover {
      background: #eef1f6;
      border-color: #cfd5dd;
    }
  }

  &-details {
    margin-top: 14px;
    text-align: left;
    background: #1e1e1e;
    color: #d4d4d4;
    border-radius: 12px;
    padding: 12px 14px;
    font-size: 12px;
    line-height: 1.5;
    max-height: 280px;
    overflow: auto;
    white-space: pre-wrap;
    word-break: break-word;
  }
}
</style>
